import React, { useState } from 'react';
import { Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import i18n from 'i18n-js';
import GoogleMapReact from 'google-map-react';

import InfiniteScroll from 'react-infinite-scroll-component';
import userDefaultImg from '../../../assets/images/user_default.png';
import emblem5Plus from '../../../assets/images/emblem_badge_5_plus.png';
import emblem10Plus from '../../../assets/images/emblem_badge_10_plus.png';
import emblem25Plus from '../../../assets/images/emblem_badge_25_plus.png';
import emblem50Plus from '../../../assets/images/emblem_badge_50_plus.png';
import trainingCourse from '../../../assets/images/training-course-icon.png';
import GoogleMapMarker from './GoogleMapMarker';
import { API } from '../../api/api';

import { map as mapConfig } from '../../../config'

export interface DavaVal {
  uid: number;
  first_name: string;
  last_name: string;
  zip: string;
  city: string;
  title: string;
  description: string;
  full_day_price: number;
  home_price: number;
  visit_price: number;
  walk_price: number;
  day_price: number;
  dogs: [];
  other_pets: [];
  property_description: string;
  garden_description: string;
  profile_picture: string;
  profile_link: string;
  latitude: number;
  longitude: number;
  user_uid: number;
  total_jobs: number;
  // threads: object[];
  // ratings: { rating: string }[];
  response_rate: number;
  total_message: number;
  average_rating: number;
  rating_count: number;
  training_course?: number;
  is_random ?: boolean;
  is_random_1 ?: boolean;
  is_random_2 ?: boolean;
  is_random_3 ?: boolean;
}

const d: any = document;
const b2b = d.getElementsByClassName("is-b2b").length ? true : false ;
const memberBenefits = d.getElementsByClassName("is-member-benefits").length ? true : false ;

const CardContent = (arr: [], key: string, favorites: number[], setStateValue: (data: object) => void, user: object) => {
  const data: DavaVal = arr[parseInt(key)];
  
  let dogsList: any = '';
  if (data && data.other_pets && data.other_pets.length) {
    const lst = data.other_pets.map((res: {description: string}) => res.description );
    dogsList = lst.join(', ');
  }
  // else if (data && data.dogs && data.dogs.length) {
  //   const lst = data.dogs.map((res: {name: string}) => res.name );
  //   dogsList = lst.join(', ');
  // }
  else {
    dogsList = i18n.t('none');
  }

  const ratingVal = Math.floor(data.average_rating);
  const isHalfHeart = data.average_rating % 1;

  let hearts = []

  for(let i = 0; i < ratingVal; ++i) {
    hearts.push(<span
        key={'rating-heart-' + i}
        className="fa fa-heart full"
      ></span>
    )
  }

  if (isHalfHeart) {
    hearts.push(<span key={ratingVal + 1} className="half-heart">
      <span className="fa fa-heart full"/>
    </span>);
  }


  const favHeart = user && (
    favorites && favorites.indexOf(data.user_uid) !== -1
    ? <i
        data-toggle="tooltip" title={i18n.t('addToFavorites')}
        className="icon-red-heart"
        onClick={async () => {
          const user = await API.removeFavorite(data.user_uid)
          setStateValue({ user: user.result })
        }}
      />
    : <i
        data-toggle="tooltip" title={i18n.t('addToFavorites')}
        className="icon-gray-heart"
        onClick={async () => {
          const user = await API.addFavorite(data.user_uid)
          setStateValue({ user: user.result })
        }}
      />
    ) || (
      <a href="#" data-toggle="modal" data-target="#signin_form">
        <i
          title={i18n.t('addToFavorites')}
          className="icon-gray-heart"
          data-toggle="tooltip"
        />
      </a>
    )

  return (
    <div className={ "list box-wrapper" + (data.is_random ? " is-random" : "") } key={key}>
        { data.is_random_1 ? <label className="red-label">{i18n.t('goodRecommendations')}</label> : null }
        { data.is_random_2 ? <label className="red-label">{i18n.t('highResponseRate')}</label> : null }
        { data.is_random_3 ? <label className="red-label">{i18n.t('newDogSitter')}</label> : null }
        <div>
            <div className="top">
              { favHeart }
              <ul>
                <li className="box-profile-photo">
                  <a href={data.profile_link} target="_blank">
                    {
                      data.profile_picture ?
                        <img src={data.profile_picture} />
                        :
                        <img src={userDefaultImg} />
                    }
                    {
                      data.total_jobs < 10 && data.total_jobs >= 5 ?
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-top">{i18n.t('popularToolTip', {count: 5})}</Tooltip>
                          }
                        >
                          <img className="emblem_points" src={emblem5Plus} />
                        </OverlayTrigger>
                      : null
                    }
                    {
                      data.total_jobs <= 24 && data.total_jobs >= 10 ?
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-top">{i18n.t('popularToolTip', {count: 10})}</Tooltip>
                          }
                        >
                          <img className="emblem_points" src={emblem10Plus} />
                        </OverlayTrigger>
                      : null
                    }
                    {
                      data.total_jobs < 50 && data.total_jobs >= 25 ?
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-top">{i18n.t('popularToolTip', {count: 25})}</Tooltip>
                          }
                        >
                          <img className="emblem_points" src={emblem25Plus} />
                        </OverlayTrigger>
                      : null
                    }
                    {
                      data.total_jobs >= 50 ?
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-top">{i18n.t('popularToolTip', {count: 50})}</Tooltip>
                          }
                        >
                          <img className="emblem_points" src={emblem50Plus} />
                        </OverlayTrigger>
                      : null
                    }
                  </a>
                </li>
                <li className="box-profile-detail">
                  <p className="name">
                    <a href={data.profile_link} target="_blank">
                      {
                        data.first_name} {
                          !b2b && !memberBenefits ?
                            `${data.last_name.charAt(0)}.`
                          : ( !memberBenefits ? `${data.last_name}` : `` )
                      }
                    </a>
                  </p>
                  <p className="address">{data.zip} {data.city}</p>
                  { !b2b && !memberBenefits ?
                      <p className="meta-data">
                        <span>{i18n.t('propertyType')}: {data.property_description}, </span>
                        <span>{i18n.t('garden')}: {data.garden_description}, </span>
                        <span>{i18n.t('ownPet')}: {dogsList}</span>
                      </p>
                      : null
                  }
                  {
                    data.average_rating ?
                      <div className="box-heart">
                        <div className="rating-heart">
                          <span className="fa fa-heart"></span>
                          <span className="fa fa-heart "></span>
                          <span className="fa fa-heart"></span>
                          <span className="fa fa-heart"></span>
                          <span className="fa fa-heart"></span>
                          <span className="rate">
                            {hearts}
                          </span>
                        </div>
                        {
                          data.rating_count > 0 ?
                            <span className="text">{data.rating_count}</span>
                            : null
                        }
                      </div>
                      : null
                  }
                </li>
              </ul>
            </div>
            <div className="mid">
              <a href={data.profile_link} target="_blank">
                <h2 className="search-ad-title">
                  {data.title.substring(0, 32) + (data.title.length > 32 && '...' || '')}
                </h2>
              </a>
              <div className="description">
                {data.description}
              </div>
              <div className="type">
                {
                  data.full_day_price ?
                    <span>{i18n.t('fullDayPrice')}</span>
                    : null
                }
                {
                  data.home_price ?
                    <span>{i18n.t('homePrice')}</span>
                    : null
                }
                {
                  data.visit_price ?
                    <span>{i18n.t('visitPrice')}</span>
                    : null
                }
                {
                  data.walk_price ?
                    <span>{i18n.t('walkPrice')}</span>
                    : null
                }
                {
                  data.day_price ?
                    <span>{i18n.t('dayPrice')}</span>
                    : null
                }
              </div>
            </div>
            <div className="bottom">
                {
                    !b2b && !memberBenefits ? 
                        <p>{i18n.t('responseRate')}: {data.response_rate ? data.response_rate + '%' : (data.total_message ? '0%' : i18n.t('new')) }</p>
                    : <p>&nbsp;</p>
                }
              {
                data.training_course ?
                  <OverlayTrigger
                    key="top"
                    placement="top"
                    overlay={
                      <Tooltip id="tooltip-top">{i18n.t('trainingCourseToolTip')}</Tooltip>
                    }
                  >
                    <img className="training_course" src={trainingCourse} />
                  </OverlayTrigger>
                  : null
              }
              <a href={data.profile_link} className="btn-round-red btn-small" target="_blank">{i18n.t('readMore')}</a>
            </div>
        </div>
    </div>
  );
};

const loadMoreData = (loadMore: () => void) => {
  loadMore();
}

const Map = (arr: [], key: string) => {
  const data: DavaVal = arr[parseInt(key)];

  return (
      <GoogleMapMarker
        key={'map-marker-' + key}
        lat={data.latitude}
        lng={data.longitude}
        color="#ff5a50"
        data={data}
      />
  )
}

const getAverageLatLng = (dataList: any): { lat: number, lng: number } => {
  if(!dataList || dataList.length < 1) {
    return { lat: 55.676098, lng: 12.568337 }
  }

  let sumLength = 0
  let latSum = 0
  let lngSum = 0

  for(let item of dataList) {
    const lat = item && item.latitude ? parseFloat(item.latitude) : 0;
    const lng = item && item.longitude ? parseFloat(item.longitude) : 0;

    if(lat > 0 && lng > 0) {
      ++sumLength
      latSum += parseFloat(item.latitude)
      lngSum += parseFloat(item.longitude)
    }
  }

  const lat = latSum / sumLength
  const lng = lngSum / sumLength

  return { lat, lng }
}

// const getResponseRate = (data: DavaVal) => {
//   let sent = 0
//   let received = 0
//
//   data.threads.forEach((thread: { sender: number, receiver: number }) => {
//     const { sender } = thread
//     if(sender == data.user_uid) {
//       ++sent
//     } else {
//       ++received
//     }
//   })
//
//   let responseRate = Math.round(sent / received * 100)
//   if(responseRate > 100) responseRate = 100
//
//   return responseRate || null
// }
//
// const getAverageRating = (data: DavaVal): number => {
//   const { ratings } = data
//
//   let ratingSum = 0
//   if(ratings && ratings.length) ratings.forEach((rating) => {
//     ratingSum = ratingSum + parseInt(rating.rating)
//   })
//   return Math.round(ratingSum > 0 && ratingSum / ratings.length)
// }

const SearchList = (props: any) => {
  const { user, dataList, loadMore, dataListTotal, limit, setStateValue, resetPage } = props;
  const [tab, setTab] = useState(false);
  const favorites = user && user.favorites && user.favorites.map(
    (favorite: { uid: number }) => favorite.uid
  )

  const avgLatLng = getAverageLatLng(dataList);

  return (
    <div className="box-search-list" id="search-result">
      <div className="box-wrapper-container">
        <div className="box-menu-list col-sm-12 box-wrapper">
          <ul>
            <li className={!tab ? 'selected' : ''} onClick={() => setTab(false)}>{i18n.t('list')}</li>
            <li className={tab ? 'selected' : ''} onClick={() => setTab(true)}>{i18n.t('showOnMap')}</li>
          </ul>
        </div>
      </div>
      {
        !tab ?
          <div className="box-wrapper-container">
            <div id="box-search-list" className="box-cards col-sm-12 box-wrapper">
            { !b2b && !memberBenefits ?
                <div className="selected-dogsitters">
                    <label data-toggle="tooltip" title={i18n.t('selectedDogsittersDesc')}>{i18n.t('selectedDogsitters')}</label>
                </div>
                : null
            }
            {
              dataList.length > 0
              ?
              (
                <InfiniteScroll
                  dataLength={dataList.length}
                  next={() => loadMoreData(loadMore)}
                  hasMore={dataListTotal === limit}
                  loader={<div className="text-align-center"><Spinner variant="danger" animation="grow" /></div>}
                  scrollThreshold={.60}
                >
                  {Object.keys(dataList).map((key) => CardContent(dataList, key, favorites, setStateValue, user) )}
                </InfiniteScroll>
              )
              :
              (
                <div className="text-align-center">
                  <Spinner variant="danger" animation="grow" />
                </div>
              )
            }
            </div>
          </div>
          :
          <div id="map" style={{height: '500px', width: '100%', margin:'20px 0 -40px' }}>

            <GoogleMapReact
              bootstrapURLKeys={mapConfig}
              defaultCenter={avgLatLng}
              defaultZoom={13}
              // onGoogleApiLoaded={({map, maps}:any) => apiIsLoaded(map, maps)}
              yesIWantToUseGoogleMapApiInternals
            >
              {Object.keys(dataList).map((key) => Map(dataList, key) )}
            </GoogleMapReact>

          </div>
      }
    </div>
  )
};

export default SearchList;
